import type { ProgramSponsor } from 'models';
import { Trans } from 'react-i18next';
import { Avatar, Flex, RichTextRenderer } from 'ui';
import { Text } from 'ui/typography';

type P = {
  sponsors: ProgramSponsor[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramSponsors = ({ sponsors }: P) => (
  <Flex className="card-wrapper card-wrapper--participants">
    <Flex className="card-content card-content--participants" vertical>
      <Text className="card-content__title">
        <Trans>Sponsored by</Trans>
      </Text>
      {sponsors.map((sponsor) => (
        <Flex className="participant-box" key={sponsor.name}>
          <Flex className="avatar-photo avatar-photo--instructors" vertical>
            <Avatar photo={sponsor.logo?.url} size={72} />
          </Flex>
          <Flex className="card-content" vertical>
            <Text className="program-sponsors__name">{sponsor.name}</Text>
            <Text className="participant-box__quote">
              <RichTextRenderer data={sponsor.htmlDescription} />
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  </Flex>
);

export default ProgramSponsors;
